export type ColorKey =
  | "brand"
  | "field"
  | "fieldBg"
  | "text"
  | "label"
  | "placeholder"
  | "error"
  | "formBg"
  | "card";

export interface ColorDef {
  key: ColorKey;
  label: string;
  dataAttr: string;
  queryParam: string;
  cssVar: string;
  fallback: string;
}

export const COLORS: ColorDef[] = [
  {
    key: "brand",
    label: "Основной цвет",
    dataAttr: "data-osago-brand",
    queryParam: "c_brand",
    cssVar: "--color-brand",
    fallback: "#457be7",
  },
  {
    key: "field",
    label: "Цвет рамок полей",
    dataAttr: "data-osago-field",
    queryParam: "c_field",
    cssVar: "--color-input-border",
    fallback: "#e5e7eb",
  },
  {
    key: "fieldBg",
    label: "Цвет полей ввода",
    dataAttr: "data-osago-field-bg",
    queryParam: "c_field_bg",
    cssVar: "--color-field-bg",
    fallback: "#ffffff",
  },
  {
    key: "text",
    label: "Цвет заголовков",
    dataAttr: "data-osago-text",
    queryParam: "c_text",
    cssVar: "--color-input-text",
    fallback: "#111827",
  },
  {
    key: "label",
    label: "Цвет подписей",
    dataAttr: "data-osago-label",
    queryParam: "c_label",
    cssVar: "--color-label-text",
    fallback: "#4b5563",
  },
  {
    key: "placeholder",
    label: "Цвет плейсхолдера",
    dataAttr: "data-osago-placeholder",
    queryParam: "c_placeholder",
    cssVar: "--color-input-placeholder",
    fallback: "#9ca3af",
  },
  {
    key: "error",
    label: "Цвет ошибки",
    dataAttr: "data-osago-error",
    queryParam: "c_error",
    cssVar: "--color-error",
    fallback: "#ef4444",
  },
  {
    key: "formBg",
    label: "Фон формы",
    dataAttr: "data-osago-form-bg",
    queryParam: "c_form_bg",
    cssVar: "--color-form-bg",
    fallback: "#ffffff",
  },
  {
    key: "card",
    label: "Цвет карточек",
    dataAttr: "data-osago-card",
    queryParam: "c_card",
    cssVar: "--color-card",
    fallback: "#ffffff",
  },
];

export type Colors = Record<ColorKey, string>;

export const EMPTY_COLORS: Colors = {
  brand: "",
  field: "",
  fieldBg: "",
  text: "",
  label: "",
  placeholder: "",
  error: "",
  formBg: "",
  card: "",
};

export const WIDGET_CLASS = "osago-widget";
export const EMBED_PATH = "/v1/embed.js";

export const ATTR = {
  partner: "data-osago-partner",
  chan: "data-osago-chan",
  b: "data-osago-b",
  showHeader: "data-osago-show-header",
  hidePromo: "data-osago-hide-promo",
  hideTitle: "data-osago-hide-title",
  product: "data-osago-product",
  companies: "data-osago-companies",
} as const;

export type ProductKey = "osago" | "pkasko";

export interface ProductDef {
  key: ProductKey;
  label: string;
  hint: string;
  /** Путь формы на хосте osago-client, который открывается в iframe. */
  path: string;
  /** companies читает только выдача ОСАГО — на своих формах продуктов параметр не применяется. */
  supportsCompanies: boolean;
}

export const PRODUCTS: ProductDef[] = [
  {
    key: "osago",
    label: "ОСАГО",
    hint: "Форма расчёта ОСАГО с выдачей предложений страховых компаний",
    path: "/",
    supportsCompanies: true,
  },
  {
    key: "pkasko",
    label: "ПКаско",
    hint: "Форма ПКаско от СК Гелиос",
    path: "/pkasko",
    supportsCompanies: false,
  },
];

export const DEFAULT_PRODUCT: ProductKey = "osago";

export function getProduct(key: ProductKey): ProductDef {
  return PRODUCTS.find((p) => p.key === key) ?? PRODUCTS[0];
}

export function isProductKey(value: string): value is ProductKey {
  return PRODUCTS.some((p) => p.key === value);
}
